module.exports = __webpack_public_path__ + "img/asset-icon.d6eedea9.svg";